import { useEffect, useState } from "react";
import CustomPopUp from "./CustomPopup";
import CustomText from "../atomic/CustomText";
import { subscribeToLogoutState } from "../../services/session/logoutState";

const noop = () => undefined;

function LogoutStatusPopup(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToLogoutState(setVisible);
    return () => unsubscribe();
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <CustomPopUp
      popUpTitle="Logging you out"
      popUpSubtitle="Please wait while we securely end your session."
      hidePopUp={noop}
      hideClose
    >
      <div className="flex flex-col items-center justify-center py-6 gap-4">
        <div className="animate-spin">
          <img
            src={require("../../assets/images/loadingPNG.png")}
            className="h-[48px] w-[48px]"
            alt="Logging out indicator"
          />
        </div>
        <CustomText
          text="Logging out…"
          fontWeight="font-medium"
          fontSize="text-base"
          className="text-royalBlue"
        />
      </div>
    </CustomPopUp>
  );
}

export default LogoutStatusPopup;

